'use client';

import React, {ReactNode, useEffect, useState, createContext, useContext, memo} from 'react';
import {GlobalEventEmitter} from '@sdk-mobile';

const FTUEContext = createContext<boolean>(false);

type Props = {
  children: ReactNode;
};

function FTUEGameProvider({children}: Props) {
  const [firstFTUEGame, setFirstFTUEGame] = useState(false);

  useEffect(() => {
    const startSubscription = GlobalEventEmitter.addListener('StartFirstFTUEMatch', () =>
      setFirstFTUEGame(true)
    );

    const endSubscription = GlobalEventEmitter.addListener('EndFirstFTUEMatch', () =>
      setFirstFTUEGame(false)
    );

    return () => {
      startSubscription.remove();
      endSubscription.remove();
    };
  }, []);

  return <FTUEContext.Provider value={firstFTUEGame}>{children}</FTUEContext.Provider>;
}

export function useFirstFTUEGame(): boolean {
  const context = useContext(FTUEContext);

  if (context === undefined) {
    console.error('useFTUEGame must be used within a FTUEGameProvider');
  }

  return context;
}

export default memo(FTUEGameProvider);
